import React from "react";
import { CruiseProvider } from "../context/CruiseContext";
import caribbean from "../data/caribbean";
import SiteLayout from "../components/SiteLayout";

const Home = () => (
  <CruiseProvider cruise={caribbean}>
    <SiteLayout />
  </CruiseProvider>
);

export default Home;
